module.exports = __webpack_public_path__ + "static/img/2.5442794.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/icon/2.png
// module id = VYsh
// module chunks = 1